module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b8c58b160051ad14a948bce004de1f24.png";